import qs from "qs";

import { axiosWithAuth } from "helpers";
import { CommissionsSplitProfilesColumns } from "types";

export const commissionSplitsService = {
	getCommissionSplitsBody,
	updateStatusCommissionSplits,
	getCommissionSplitInfo,
	addCommissionSplit,
	updateCommissionSplit,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getCommissionSplitsBody({
	agentId,
	page,
	sortBy,
}: {
	agentId: string;
	page: number;
	sortBy: { [key: string]: any };
}) {
	const body = {
		page_index: page,
		sort_type:
			CommissionsSplitProfilesColumns.getByName(
				sortBy?.id,
			)?.value?.toString() || undefined,
		ascending: sortBy?.desc,
		page_size: PAGE_SIZE,
	};
	const options = {
		url: `${API_URL}/api/agents/${agentId}/commissions/split_profiles`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function updateStatusCommissionSplits({
	active,
	agentId,
	commissionId,
}: {
	active: boolean;
	agentId: string;
	commissionId: string;
}) {
	return axiosWithAuth({
		method: "PUT",
		data: { is_active: active },
		url: `${API_URL}/api/agents/${agentId}/commissions/split_profiles/${commissionId}/update_status`,
	});
}

function getCommissionSplitInfo(agentId: string, commissionId: string) {
	const options = {
		url: `${API_URL}/api/agents/${agentId}/commissions/split_profiles/${commissionId}`,
	};

	return axiosWithAuth(options);
}

function addCommissionSplit(agentId: string, data: { [key: string]: any }) {
	const options = {
		method: "POST",
		data,
		url: `${API_URL}/api/agents/${agentId}/commissions/split_profiles`,
	};

	return axiosWithAuth(options);
}

function updateCommissionSplit(
	agentId: string,
	commissionId: string,
	data: { [key: string]: any },
) {
	const options = {
		method: "PUT",
		data,
		url: `${API_URL}/api/agents/${agentId}/commissions/split_profiles/${commissionId}`,
	};

	return axiosWithAuth(options);
}
